module.exports = __webpack_public_path__ + "static/media/CredNexNew.7f3e19ff.svg";